import _ from "lodash";
import React, { useState } from "react";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import { api, constants } from "../utils";

export default function ItemTypeahead(props) {
   const [inputValue, setInputValue] = useState("");
   const [loading, setLoading] = useState(false);
   const groupStyle = {
      alignItems: 'center',
      fontSize: 14,
      fontWeight: 'bold',
      margin: '2px 0 0 0'
   };

   const groupLabelFormat = data => (
      <div style={groupStyle}>
         <span>{data.label}</span>
      </div>
   );

   const groupOptions = (list) => {
      const [sampleItems, productionItems] = _.partition(list, x => x.isSample);
      let result = [];
      if (productionItems.length) {
         result.push({
            label: "***** Production Items *****",
            options: productionItems
         });
      }
      if (sampleItems.length) {
         result.push({
            label: "***** Sample Items *****",
            options: sampleItems
         });
      }
      return result;
   };

   function getApiEndPoint(filterItemBy) {
      let apiEndPoint = "";
      switch (filterItemBy) {
         case constants.TYPE_AHEAD_CLASSES.SpecItemsWithAllActiveSamples:
            apiEndPoint = "Item/SpecItemsWithAllActiveSamplesTypeahead";
            break;

         case constants.TYPE_AHEAD_CLASSES.SpecificationItems:
            apiEndPoint = "Item/ItemTypeAheadGetSpecItems"
            break;

         // case constants.TYPE_AHEAD_CLASSES.SalesCallList:
         //   // Your code for SalesCallList
         //   break;

         // case constants.TYPE_AHEAD_CLASSES.MachineParts:
         //   // Your code for MachineParts
         //   break;

         // case constants.TYPE_AHEAD_CLASSES.RawMaterials:
         //   // Your code for RawMaterials
         //   break;

         // case constants.TYPE_AHEAD_CLASSES.VendorList:
         //   // Your code for VendorList
         //   break;

         default:
            apiEndPoint = "Item/Typeahead";
            break;
      }
      return apiEndPoint;
   }

   const loadItemOptions = (typedValue, callback) => {
      if (!typedValue || !typedValue.length || typedValue.length < 2) return;

      let payload = { searchString: typedValue };
      if (props.machinePartsOnly) payload.isMachinePart = true;
      if (props.includeSampleItems) payload.includeSampleItems = true;
      if (props.purchasedMaterialsOnly) payload.isPurchasedMaterial = true;

      setLoading(true);
      const apiEndPoint = getApiEndPoint(props.filterItemBy);
      api
         .post(apiEndPoint, payload)
         .then((response) => {
            let list = _.map(response.data, (d) => {
               d.label = d.itemWithDesc;
               d.value = d.itemNumber;
               // need all the values for other
               return d;
            });
            if (props.includeSampleItems) {
               callback(groupOptions(list));
            } else {
               callback(list);
            }
         })
         .catch(() => {
            toast.error("There was an error loading item information.");
            callback([]);
         })
         .finally(() => setLoading(false));
   }

   return (
      <AsyncSelect
         id={props.id || ""}
         classNamePrefix='serviceThreadSelect'
         loadOptions={loadItemOptions}
         onInputChange={(e) => setInputValue(e)}
         onChange={props.onChange}
         formatGroupLabel={groupLabelFormat}
         inputValue={inputValue}
         value={props.value}
         onFocus={props.onFocus}
         placeholder={props.placeholder || "Type the item number you are looking for"}
         noOptionsMessage={() => "Start typing to search Items"}
         isLoading={loading}
         isDisabled={props.disabled}
         isClearable
      />
   );
} 